/**
 * The device wall clock as 'HH:mm', refreshed every 30 seconds.
 *
 * The "Maintenant" chip shows a live time, so it must not go stale while the
 * parent is looking at the screen — a dose logged from a 10-minute-old chip
 * would record the wrong minute.
 */
import { useEffect, useState } from 'react';

function read(): string {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function useClock(): string {
  const [now, setNow] = useState(read);
  useEffect(() => {
    const id = setInterval(() => setNow(read()), 30_000);
    return () => clearInterval(id);
  }, []);
  return now;
}
